export class Machine {
  constructor(
    public hash?: string,
    public name?: string,
    public code?: string,
    public active?: boolean,
    public fileType?: string,
    public path?: string,
    public inputPath?: string,
    public outputPath?: string,
    public successPath?: string,
    public failedPath?: string,
    public isZoller?: boolean,
    public isHaimer?: boolean
  ) { }

  clone() {
    return new Machine (
      this.hash,
      this.name,
      this.code,
      this.active,
      this.fileType,
      this.path,
      this.inputPath,
      this.outputPath,
      this.successPath,
      this.failedPath,
      this.isZoller,
      this.isHaimer
    );
  }

}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/models/machine.ts